import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "react-query";
import { CancelWaitForSettlementSale } from "../../services/settlement.service";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { AggregatedSaleWalletDetail } from "../../models/customer.model";
const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  maxWidth: 550,
  textAlign: "center",
};
interface modalProps {
  amount: number;
  aggregatedSaleWalletDetail: AggregatedSaleWalletDetail[];
  customer: string;
  cash?: number;
  pay?: string;
  saleKey: string;
}
export default function ModalHeaderWithSalesInvoiceRejectionAfterCustomerPurchase({
  amount,
  customer,
  aggregatedSaleWalletDetail,
  cash,
  pay,
  saleKey,
}: modalProps) {
  const [open, setOpen] = React.useState(false);
  const history = useHistory();
  const { mutate: CancelWaitForSettlementSaleMutate } = useMutation(
    CancelWaitForSettlementSale,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          toast.success("لغو فاکتور با موفقیت انجام شد.");
          window.location.reload();
        }
      },
      onError: () => {},
    },
  );
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    CancelWaitForSettlementSaleMutate({ saleKey: saleKey });
    setOpen(false);
  };

  return (
    <div>
      <span style={{ color: "red", cursor: "pointer" }} onClick={handleOpen}>
        <CloseIcon /> لغو فاکتور فروش
      </span>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="cancel-sale-modal-title"
        aria-describedby="cancel-sale-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              paddingBottom: "15px",
              color: "#1D4A87",
              fontWeight: "bold",
            }}
          >
            لغو فاکتور فروش
          </div>
          {aggregatedSaleWalletDetail.length === 1 ? (
            <Typography
              id="cancel-sale-modal-description"
              sx={{ mb: 3, lineHeight: "23px" }}
            >
              آیا از <span style={{ color: "#E6123D" }}> فروش</span> و برگشت
              تراکنش به مبلغ{" "}
              <span style={{ color: "#E6123D" }}>
                {amount?.toLocaleString()} ریال
              </span>{" "}
              به{" "}
              <span style={{ color: "#E6123D" }}>
                {aggregatedSaleWalletDetail[0].walletName}
              </span>{" "}
              متعلق به <span style={{ color: "#E6123D" }}>{customer}</span>{" "}
              اطمینان دارید؟
            </Typography>
          ) : (
            <>
              <Typography
                id="cancel-sale-modal-description"
                sx={{ mb: 3, lineHeight: "23px" }}
              >
                آیا از <span style={{ color: "#E6123D" }}>لغو فاکتور فروش</span>{" "}
                و برگشت تراکنش به مبلغ{" "}
                <span style={{ color: "#E6123D" }}>
                  {amount?.toLocaleString()} ریال
                </span>{" "}
                به کیف پول های زیر که متعلق به{" "}
                <span style={{ color: "#E6123D" }}>{customer}</span> اطمینان
                دارید؟
              </Typography>
              <Grid container spacing={0}>
                {aggregatedSaleWalletDetail.map((item, index) => (
                  <Grid item xs={12} key={index}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      border="1px solid #ddd"
                      borderRadius="2px"
                      p={1.5}
                    >
                      <Box textAlign="right">{item.walletName}</Box>

                      <Box textAlign="left">
                        {item.walletAmount.toLocaleString()} ریال
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          {cash && cash > 0 && pay ? (
            <>
              <Typography
                id="cancel-sale-modal-description"
                sx={{
                  mb: 3,
                  mt: 3,
                  border: "1px solid #DAE0E4",
                  borderRadius: "5px",
                  background: "#75757508",
                  textAlign: "justify",
                  padding: "15px",
                  lineHeight: "23px",
                }}
              >
                توجه داشته باشید که مبلغ{" "}
                <span style={{ color: "#E6123D" }}>
                  {cash?.toLocaleString()} ریال
                </span>{" "}
                به صورت نقدی توسط درگاه پرداخت{" "}
                <span style={{ color: "#E6123D" }}>{pay}</span> از مشتری دریافت
                شده است و باید به ایشان بازگردادنده شود.
              </Typography>
            </>
          ) : null}
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="contained"
                className="btnForm DangerDefault"
                onClick={handleConfirm}
              >
                بله، فروش لغو شود
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                className="ComingBack btnForm"
                onClick={handleClose}
              >
                خیر، فروش لغو نشود
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
